import React, { useState } from 'react';
import Table from './Table';


import initialColumns from './columns';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import useQuery from './useQuery';

export default function Team(_props) {


  const PAGE_SIZE = 50;

  const [columns, _setColumns] = useState(initialColumns);

  const selectedColumns = columns.filter((column) => column.selected);

  const users = useQuery({
    // search: queryString.parse(location.search),
    pageSize: PAGE_SIZE
  });

  if (users.state === PayloadStates.FETCHING) {
    return (
      <Loader />);

  }

  return (
    <Table
      pageSize={PAGE_SIZE}
      columns={selectedColumns}
      select={function (_getState) {
        return users;
      }}
      row={function (user, index) {
        return (
          <tr key={index}>
            {selectedColumns.map(function (column) {
              if (!column.row) {
                return null;
              }

              return (
                <column.row
                  key={column.id}
                  user={user} />);


            })}
          </tr>);

      }} />);


}